export enum TestRunStatus {
	Draft,
	Final,
}
